class ScrollToTop extends HTMLElement{
    connectedCallback(){
        // Scroll back to top when clicked
        this.addEventListener("click", () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        // Check for button position on load
        this.showButton();

        // Element shows up when scrolling
        document.addEventListener("scroll", () => {
            this.showButton();
        });

        // Align button below the Reviews widget
        this.alignBelowReviews();

        // Re-align on resize
        window.addEventListener("resize", () => {
            this.alignBelowReviews();
        });
    }

    alignBelowReviews(){
        // 尝试找 Reviews 浮动块（常见选择器）
        var reviews = document.querySelector(
            '.stamped-badge-widget, .jdgm-widget, .reviews-widget, ' +
            '[class*="review"][class*="float"], [class*="float"][class*="review"], ' +
            '.spr-badge, #stamped-reviews-widget, ' +
            'a[href*="reviews"], .floating-reviews, ' +
            '[class*="sidebar"][class*="review"]'
        );

        // 如果找不到，fallback 到加购栏上方
        if(!reviews){
            var stickyBar = document.querySelector('sticky-add-to-cart');
            if(stickyBar){
                var barHeight = stickyBar.offsetHeight || 80;
                this.style.bottom = (barHeight + 12) + 'px';
                this.style.right = '0px';
                this.style.left = 'auto';
            }
            return;
        }

        var rect = reviews.getBoundingClientRect();
        var gap = 8; // Reviews块与按钮的间距(px)

        // 水平：与 Reviews 块中心对齐
        var reviewsCenterX = rect.left + rect.width / 2;
        var btnHalfWidth = this.offsetWidth / 2;
        var rightFromEdge = window.innerWidth - reviewsCenterX - btnHalfWidth;

        // 垂直：紧贴 Reviews 块下方
        var bottomFromEdge = window.innerHeight - rect.bottom - gap;

        this.style.right = Math.max(0, rightFromEdge) + 'px';
        this.style.left = 'auto';
        this.style.bottom = Math.max(0, bottomFromEdge) + 'px';
        this.style.position = 'fixed';
    }

    showButton(){
        if(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20){
            this.classList.add("active");
        }
        else{
            if(this.classList.contains('active')){
                this.classList.remove("active");
            }
        }
    }
}

customElements.get("scroll-to-top") || customElements.define("scroll-to-top", ScrollToTop);